<template>
  <div class="modal fade" id="top-up-result-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div :class="[{'pay-failed-box' : !loading && orderInfo.state !== 'paid'},'modal-dialog']" role="document">
      <div class="modal-content loading" v-if="loading">
        <spinner :show="loading" class="spinner-component"></spinner>
      </div>

      <template v-if="!loading">
        <div class="modal-content" id="pay-success" v-if="orderInfo.state === 'paid'">
          <modal-header></modal-header>
          <div class="modal-body text-center">
            <img src="/static/img/dashboard/success_2x.png" alt=" " />
            <h4 class="text-center">{{ $t('paid') }}</h4>
            <p class="payment-info">
              <span>{{ $t('price') }}</span>
              <span class="pull-right">{{ $t(orderInfo.order_detail.currency_symbol) }} {{ orderInfo.order_detail.total_amount }}</span>
            </p>
            <p class="payment-info">
              <span>{{ $t('deviceNum') }}</span>
              <span class="pull-right">{{ orderInfo.max_device_count }} {{ $tc('devices', orderInfo.max_device_count) }}</span>
            </p>
            <p class="payment-info">
              <span>{{ $t('packageTime') }}</span>
              <span
                class="pull-right"
              >{{ orderInfo.value_of_expire_in }} {{ $tc(orderInfo.unit_of_expire_in, orderInfo.value_of_expire_in) }}</span>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" @click="gtmEvent('payment_success')">{{ $t('sure') }}</button>
          </div>
        </div>

        <div class="modal-content" id="pay-failed" v-else>
          <modal-header></modal-header>
          <div class="modal-body text-center">
            <img src="/static/img/dashboard/failure_2x.png" alt=" " />
            <h4 class="text-center">{{ $t('payFailed') }}</h4>
            <p v-if="errorNotice">{{ errorNotice }}</p>
            <p v-else>{{ $t('failedNotice') }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" @click="gtmEvent('payment_fail')">{{ $t('sure') }}</button>
            <p>{{ $t('contactUs') }}</p>
            <p class="email">iplexservice@gmail.com</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Spinner from '../../Spinner.vue';
import ModalHeader from '../../modalHeader/ModalHeader.vue';
import $ from 'jquery';
import locales from './lang';
import { addProduct, setAction } from '../../../assets/js/ecommerceAnalytics';
import { mapState } from 'vuex';
import { isMobile, isAndroid, isIOS, isMac, isWindows } from '../../../lib/fun';
import cookie from '../../../lib/cookie';

const UaRechargeActions = {
  PAYMENT_SUCCESS: 'Payment success',
  PAYMENT_FAILED: 'Payment failed'
};

export default {
  name: 'top-up-result-modal',
  components: { Spinner, ModalHeader },
  data: function() {
    return {
      loading: false,
      orderInfo: '',
      notFindOrder: this.$t('notFindOrder'),
      errorNotice: '',
      orderTracked: ''
    };
  },
  computed: {
    showCurrentComponent() {
      return this.queryPayStatus && !!this.orderNumber;
    },
    removeStorageInfo() {
      return !!this.$route.query.order_num;
    },
    currentPackageId() {
      if (window.localStorage.getItem('currentPackageId')) {
        return window.localStorage.getItem('currentPackageId');
      }
    },
    utmCampaign() {
      if (window.sessionStorage.getItem('utmCampaign')) {
        return window.sessionStorage.getItem('utmCampaign');
      }
    },
    ...mapState({
      orderNumber: state => state.topup.orderNumber,
      queryPayStatus: state => state.topup.queryPayStatus,
      currentSymbol: state => state.currentSymbol
    })
  },
  locales,
  watch: {
    showCurrentComponent() {
      if (this.showCurrentComponent) {
        $('#top-up-result-modal').modal('show');
        this.orderTracked = window.localStorage.getItem('orderTracked');
        this.getOrderInfo();
      }
    }
  },
  mounted() {
    let _this = this;
    $('#top-up-result-modal').on('hidden.bs.modal', function() {
      _this.resetData();
      _this.$store.commit('setUpdatePackageInfo', true);
    });
  },
  methods: {
    getOrderInfo() {
      this.loading = true;
      this.$http.get('api/topup-order/' + this.orderNumber).then(response => {
        this.loading = false;
        switch (response.body.code) {
          case 0: {
            if (response.body.code === 0) {
              this.orderInfo = response.body.data;
              if (this.orderInfo.state === 'paid') {
                if (cookie.getCookie('promotion_source')) {
                  cookie.removeCookie('promotion_source');
                }
              }
              if (this.orderInfo.state === 'paid' && !this.orderTracked) {
                this.trackPackage(this.orderInfo);
                this.trackRecharge(UaRechargeActions.PAYMENT_SUCCESS);
                this.trackCampaignRecharge();
              } else {
                this.trackRecharge(UaRechargeActions.PAYMENT_FAILED);
              }
              // TODO Tracking code
              if (process.env.NODE_ENV !== 'production') {
                const img = document.createElement('img');
                const script = document.createElement('script');
                // tracking={{order ID}} &amount={{order amount}}
                img.src = `https://tracking-mopubi.sample-try.com/transaction?merchantID=c4s8mqls53pac3ihqcpg&amount=${this.orderInfo.order_detail.total_amount}&sub_total=${this.orderInfo.order_detail.total_amount}&shipping_fee=0&tracking=${this.orderNumber}`;
                img.width = 1;
                img.height = 1;
                script.src = `https://s3.cn-north-1.amazonaws.com.cn/testimg/js/c4s8mqls53pac3ihqcpg.js`;
                script.defer = 'defer';
                document.body.appendChild(img);
                document.body.appendChild(script);
              }
            }
            break;
          }
          case 130: {
            this.errorNotice = this.notFindOrder;
            break;
          }
        }
      });
    },
    resetData() {
      this.loading = false;
      this.orderInfo = '';
      this.errorNotice = '';
      this.$store.commit('setOrderNumber', '');
      this.$store.commit('setQueryPayStatus', false);
      if (this.removeStorageInfo) {
        window.localStorage.removeItem('orderNumber');
        window.localStorage.removeItem('isQueryPayStatus');
        window.localStorage.removeItem('currentPackageId');
        window.localStorage.removeItem('currentPackage');
        window.localStorage.removeItem('orderTracked');
      }
      this.$store.commit('setCurrentPayment', '');
      this.$store.dispatch('getUserInformation');
    },
    daysToMonths(days) {
      let months = parseInt(days / 30);
      if (months > 12) {
        months = parseInt(days / 365) * 12 + (days % 365) / 30;
      }
      let monthsName = months > 1 ? 'Months' : 'Month';
      return months + ' ' + monthsName;
    },
    trackPackage(orderInfo) {
      let deviceName = orderInfo.order_detail.device_count > 1 ? 'Devices' : 'Device';
      let packageName =
        this.daysToMonths(orderInfo.order_detail.available_days) + '/' + orderInfo.order_detail.device_count + ' ' + deviceName;

      addProduct(
        {
          id: this.currentPackageId,
          name: packageName,
          price: orderInfo.order_detail.total_amount,
          deviceCount: orderInfo.order_detail.device_count,
          quantity: 1
        },
        this.currentSymbol
      );
      setAction('purchase', {
        id: orderInfo.order_id,
        revenue: orderInfo.order_detail.total_amount,
        list: 'PlexVPN',
        payMethod: orderInfo.order_detail.payment_method_id
      });
    },
    trackRecharge: function(action) {
      // The value (the last argument) must be an integer
      this.$ga.event('Recharge', action, this.orderInfo.order_detail.plan_name, parseInt(this.orderInfo.order_detail.total_amount));
    },
    trackCampaignRecharge() {
      if (this.utmCampaign === 'year-plan-promotion') {
        this.$ga.event('Promotional recharge success', 'Payment success', 'From promotional email');
      }
      window.localStorage.setItem('orderTracked', true);
    },
    gtmEvent(eventName) {
      if (isMobile()) {
        if (isAndroid()) {
          eventName = 'Android_H5_' + eventName;
        } else if (isIOS()) {
          eventName = 'iOS_H5_' + eventName;
        } else {
          eventName = 'other_H5_' + eventName;
        }
      } else {
        if (isMac()) {
          eventName = 'Mac_PC_' + eventName;
        } else if (isWindows()) {
          eventName = 'Windows_PC_' + eventName;
        } else {
          eventName = 'other_PC_' + eventName;
        }
      }
      if (eventName.indexOf('payment_success') !== -1) {
        window.dataLayer &&
          window.dataLayer.push({
            event: eventName, // Event snippet for payment page
            pageCategory: 'payment',
            transactionId: this.orderInfo.order_id,
            transactionTotal: this.orderInfo.order_detail.total_amount,
            transactionCurrency: this.orderInfo.order_detail.currency_symbol,
            transactionProducts: [
              {
                name: this.orderInfo.order_detail.plan_name,
                price: this.orderInfo.order_detail.plan_fee,
                deviceCount: this.orderInfo.order_detail.device_count
              }
            ],
            ecommerce: {
              purchase: {
                actionField: {
                  id: this.orderInfo.order_id, // Transaction ID. Required for purchases and refunds.
                  revenue: this.orderInfo.order_detail.total_amount, // Total transaction value (incl. tax and shipping)
                  currency: this.orderInfo.order_detail.currency_symbol
                },
                products: [
                  {
                    // List of productFieldObjects.
                    name: this.orderInfo.order_detail.plan_name, // Name or ID is required.
                    price: this.orderInfo.order_detail.plan_fee,
                    deviceCount: this.orderInfo.order_detail.device_count
                  }
                ]
              }
            }
          });
      } else {
        window.dataLayer &&
          window.dataLayer.push({
            event: eventName, // Event snippet for payment page
            pageCategory: 'payment',
            transactionId: this.orderInfo.order_id,
            transactionTotal: this.orderInfo.order_detail.total_amount,
            transactionCurrency: this.orderInfo.order_detail.currency_symbol,
            transactionProducts: [
              {
                name: this.orderInfo.order_detail.plan_name,
                price: this.orderInfo.order_detail.plan_fee,
                deviceCount: this.orderInfo.order_detail.device_count
              }
            ]
          });
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'index';
</style>





// WEBPACK FOOTER //
// TopUpResult.vue?ec1936b8